import { render, staticRenderFns } from "./NotificationsManagement.vue?vue&type=template&id=c8ff44da&scoped=true&"
import script from "./NotificationsManagement.vue?vue&type=script&lang=js&"
export * from "./NotificationsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ff44da",
  null
  
)

export default component.exports